import { ChevronDown, ChevronUp } from "react-feather";
import { CardHeader } from "reactstrap";
import { Btn, H2 } from "../../../../AbstractElements";
import { HeaderWithIconPropsTypes } from "../../../../Types/SocialAppType";

const HeaderWithIcon:React.FC<HeaderWithIconPropsTypes> = ({ setIsOpen, isOpen, Heading }) => {
  return (
    <CardHeader>
      <H2 className="mb-0">
        <Btn block  color="transparent" className="btn-link text-start d-flex justify-content-between" onClick={() => setIsOpen(!isOpen)}>
          {Heading}
          {isOpen ? (<ChevronUp className="m-0" />) : (<ChevronDown className="m-0" />)}
        </Btn>
      </H2>
    </CardHeader>
  );
};

export default HeaderWithIcon;
